import React from "react";
import { useNavigate } from "react-router-dom";
import Path from "app/route/Path";
import AnalyzeBox from "./AnalyzeBox";
import CustomPieChart from "../../components/CustomPieChart";

function CustomerRepeatRateAnalyze(props) {
  const navigate = useNavigate();
  return (
    <AnalyzeBox
      title="リピート率"
      onClickTitle={() => navigate(Path.customerRepeatRateAnalyzeManagement)}
    >
      <CustomPieChart rate={0.6} />
    </AnalyzeBox>
  );
}

export default CustomerRepeatRateAnalyze;
